const dashToSlash = (date) => date.replace(/-/g, '/');

export default dashToSlash;
